import { useEffect, useRef } from 'react';

const useScrollToActiveRow = (
  rows,
  isActiveRow,
  scrollDelay = 250,
  minRankToScroll = 7
) => {
  const scrollContainerRef = useRef(null);
  const activeRowRef = useRef(null);
  const hasScrolledRef = useRef(false);
  const isActiveRowRef = useRef(isActiveRow);
  const isInitialMountRef = useRef(true);

  useEffect(() => {
    isActiveRowRef.current = isActiveRow;
  }, [isActiveRow]);

  useEffect(() => {
    if (!isInitialMountRef.current || hasScrolledRef.current) 
      return
    

    if (!scrollContainerRef.current || !activeRowRef.current) {
      return;
    }

    const currentUserIndex = rows.findIndex((row) => isActiveRowRef.current(row));
    if (currentUserIndex === -1) {
      hasScrolledRef.current = true;
      isInitialMountRef.current = false;
      return;
    }

    const timer = setTimeout(() => {
      const container = scrollContainerRef.current;
      const rowEl = activeRowRef.current;

      if (!container || !rowEl) {
        hasScrolledRef.current = true;
        isInitialMountRef.current = false;
        return;
      }

      const containerRect = container.getBoundingClientRect();
      const rowRect = rowEl.getBoundingClientRect();

      const rowTopRelativeToContainer = rowRect.top - containerRect.top + container.scrollTop;
      const rowHeight = rowRect.height;
      const containerHeight = container.clientHeight;
      const targetScrollTop = rowTopRelativeToContainer - (containerHeight / 2) + (rowHeight / 2);

      container.scrollTo({
        top: Math.max(0, Math.min(targetScrollTop, container.scrollHeight - containerHeight)),
        behavior: 'smooth',
      });

      hasScrolledRef.current = true;
      isInitialMountRef.current = false;
    }, scrollDelay);

    return () => clearTimeout(timer);
  }, [rows, scrollDelay]); // הסרתי hasScrolled ו-isActiveRow מה-dependencies

  // בדיקה אם זה הטעינה הראשונית - רק כשהשורות מוכנות
  useEffect(() => {
    if (rows.length > 0 && isInitialMountRef.current) {
      // נחכה קצת כדי לוודא שהדום מוכן
      const checkTimer = setTimeout(() => {
        isInitialMountRef.current = true;
      }, 100);
      return () => clearTimeout(checkTimer);
    }
  }, [rows.length]);

  return { scrollContainerRef, activeRowRef };
};

export default useScrollToActiveRow;